
































import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import { mapGetters } from 'vuex';
import { Component, Mixins } from 'vue-property-decorator';
import Conversation from '@/components/Messages/Conversation.vue';
import ConversationData from '@/ts/ConversationData';
import Feed from '@/components/Messages/Feed.vue';
import MobileAddPerson from '@/components/Messages/Feed/MobileAddPerson.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import MessageMethods from '@/mixins/MessageMethods.vue';
import Participants from '@/components/Messages/Participants.vue';

@Component({
    computed: {
        ...mapGetters({
            conversations: 'Messages/conversationList',
        }),
    },
    components: {
        Conversation,
        Feed,
        MobileAddPerson,
        Participants,

    },
})
export default class Messages extends Mixins(DeviceMethods, MessageMethods) {
    // Class members
    get searchFieldIconClasses(): object {
        return {
            'hococo-faded-out': (this.messageSearchTerms !== ''),
        };
    }

    get searchFieldClasses(): object {
        return {
            'hococo-search-expanded': (this.messageSearchTerms !== ''),
        };
    }

    get activeConversation() {
        return this.$store.getters['Messages/activeConversation'];
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get fullScreenImageMode() {
        return (this.view.viewMode === ViewModes.Messages.FullScreenImage);
    }

    get conversationsMode() {
        return (this.view.viewMode === ViewModes.Messages.Conversations);
    }

    get messagesMode() {
        return (this.view.viewMode === ViewModes.Messages.Messages);
    }

    get addPersonMode() {
        return (this.view.viewMode === ViewModes.Messages.AddPerson);
    }

    get participantsMode() {
        return (this.view.viewMode === ViewModes.Messages.Participants);
    }

    // Lifetime hooks
    constructor() {
        super();
    }

    public beforeCreate() {
        const viewMode = (typeof this.$route.params.conversationId !== 'undefined')
            ? ViewModes.Messages.Messages : ViewModes.Messages.Conversations;

        this.$store.commit(Mutations.SET_VIEW, { view: Views.Messages });
        this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, viewMode);

        this.$store.commit(Mutations.TOGGLE_SEARCH_FIELD, true);
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.TOGGLE_SEARCH_FIELD, false);
    }

    // Methods
    public setActiveConversation(conversation: ConversationData) {
        const routerPush = this.activeConversation.id !== conversation.id;

        this.$store.commit(Mutations.UPDATE_ACTIVE_CONVERSATION, conversation.id);

        if (conversation.hasUnseenMessages === true) {
            this.$store.dispatch(Actions.MARK_ACTIVE_CONVERSATION_AS_SEEN);
        }

        this.$store.commit(Mutations.SET_MESSAGES_VIEW_MODE, ViewModes.Messages.Messages);

        if (routerPush) {
            this.$router.push({
                name: 'messages',
                params: {
                    conversationId: conversation.id.toString(),
                },
            });
        }
    }

    private getData() {
        return;
    }
}
